import { useState } from 'react'
import { JACKPOT_OVERVIEW_TAB } from '@constants/jackpotConstants'
import JackpotContributionsTab from './JackpotContributionsTab'
import JackpotPrizesTab from './JackpotPrizesTab'
import JackpotResultsTab from './JackpotResultsTab'
import JackpotRulesTab from './JackpotRulesTab'

// Contributions/Prizes/Rules (Active) or Contributions/Results/Rules
// (History) — the tab SET is keyed by viewType (see jackpotConstants.js).
// Local state (not persisted) is correct here — JackpotDetail is freshly
// mounted every time a jackpot is opened, same reasoning as Tournaments'
// TournamentOverviewTabs.
const JackpotOverviewTabs = ({ jackpot, viewType }) => {
  const tabs = JACKPOT_OVERVIEW_TAB[viewType] ?? JACKPOT_OVERVIEW_TAB.ACTIVE
  const [currentTab, setCurrentTab] = useState(tabs[0]?.KEY)
  const activeIndex = tabs.findIndex((tab) => tab.KEY === currentTab)

  const renderContent = () => {
    switch (currentTab) {
      case 'CONTRIBUTIONS':
        return <JackpotContributionsTab jackpotId={jackpot.id} viewType={viewType} />
      case 'PRIZES':
        return <JackpotPrizesTab jackpotId={jackpot.id} />
      case 'RESULTS':
        return <JackpotResultsTab jackpotId={jackpot.id} />
      case 'RULES':
        return <JackpotRulesTab />
      default:
        return null
    }
  }

  return (
    <div className="standard-normal-jackpot-overview-outer-container">
      <div
        className="standard-normal-jackpot-overview-tabs-container"
        style={{
          '--jackpot-overview-tab-count': tabs.length,
          '--jackpot-overview-tab-index': activeIndex,
        }}
      >
        {tabs.map((tab) => (
          <div
            key={tab.KEY}
            className={`standard-normal-jackpot-overview-tab ${tab.KEY === currentTab ? 'standard-normal-jackpot-overview-active-tab' : ''}`}
            onClick={() => setCurrentTab(tab.KEY)}
          >
            {tab.LABEL}
          </div>
        ))}
        <span className="standard-normal-jackpot-overview-tab-indicator" aria-hidden="true" />
      </div>

      <div className="standard-normal-jackpot-overview-content-container">{renderContent()}</div>
    </div>
  )
}

export default JackpotOverviewTabs
